import React from 'react';
import {FeedCommentList, UserImageBlock, UserImage, CommentInfoArea, UserName, CommentText, CommentBottomBlock, CommentTime, ReplyButton, ReplyCountBlock, ReplyCount} from './style';
import appInfoContainer from 'auth/appInfoContainer'
import { formatCommentDate } from 'utils/utils';
import DotButton from 'components/presenters/button/DotButton';
import FeedCommentReply from 'components/presenters/feed/detail/FeedCommentReply';

const FeedComment = ({commentItem, userInfo, handleCommentBottomModal, onReplyClick, handleShowReply, replyList, handleNextLoadReply, handleReplyDeleteBottomModal}) => {
    const countMoreReplies = (replyListLength, commentTotalReply) => {
        const moreReplyNum = commentTotalReply - replyListLength;
        if(moreReplyNum <= 5)
        {
            return moreReplyNum;
        }
        return 5;
    }
    return(
            <FeedCommentList>
                <UserImageBlock>
                    <UserImage src={`${appInfoContainer.imagePath}/user_profile_img/${commentItem['profile_img']}`}/>
                </UserImageBlock>
                <CommentInfoArea>
                    <UserName>{commentItem['nickname']}</UserName>
                    <CommentText>{commentItem['content']}</CommentText>
                    <CommentBottomBlock>
                        <CommentTime>{formatCommentDate(commentItem['create_date'])}</CommentTime>
                        <ReplyButton onClick={() => onReplyClick(commentItem)}>답글 달기</ReplyButton>
                    </CommentBottomBlock>
                    {commentItem['total_reply'] ? (
                        <ReplyCountBlock>
                            {replyList ? 
                            Object.keys(replyList).includes(commentItem['no'])
                            ? (
                                replyList[commentItem['no']].length >= commentItem['total_reply'] ?
                                (
                                    <ReplyCount onClick={() => handleShowReply(commentItem)}>
                                        답글 숨기기
                                    </ReplyCount>
                                ) : (
                                    <ReplyCount onClick={() => handleNextLoadReply(commentItem['no'])}>
                                        이전 답글 {countMoreReplies(replyList[commentItem['no']].length, commentItem['total_reply'])}개 보기
                                    </ReplyCount>
                                )
                            ) : (
                                <ReplyCount onClick={() => handleShowReply(commentItem)}>
                                    답글 {commentItem['total_reply']}개 보기
                                </ReplyCount>
                            ) : (
                                <ReplyCount onClick={() => handleShowReply(commentItem)}>
                                    답글 {commentItem['total_reply']}개 보기
                                </ReplyCount>
                            ) }
                        </ReplyCountBlock>  
                    ) : null}
                    
                    {replyList ? 
                        Object.keys(replyList).map((commentNo) => 
                            commentNo === commentItem['no'] ? (
                                <div key={`feed-comment-no-${commentNo}-reply`}>
                                    {replyList[commentNo].map((replyItem) => 
                                        <FeedCommentReply key={`feed-comment-reply-no-${replyItem['no']}`} replyItem={replyItem} userInfo={userInfo} handleReplyDeleteBottomModal={handleReplyDeleteBottomModal}/>
                                    )}
                                </div>
                            ) : null
                        )
                    : null}
                </CommentInfoArea>
                {userInfo['id'] === commentItem['user_no'] || userInfo['role'] === 'admin' ? <DotButton onClick={() => handleCommentBottomModal(commentItem)}/> : null}
            </FeedCommentList>
    );
}

export default FeedComment;